import Cookies from "js-cookie"
import useCheckToken from "./useCheckToken.js";
import { useContext } from "react";
import { store } from "../store.js";
import { useHistory } from "react-router-dom";
import axios from 'axios';

const useAxiosOperation = () => {
  const isTokenExpired = useCheckToken();
  const history = useHistory();
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const callAxios = (request, withToken=false) => {
    if (withToken) {
      if(isTokenExpired(globalState.state.accessToken))
        return callTokenRequest(request)
      else
        return callRequest(request, globalState.state.accessToken);

    }
    else
      return callRequest(request); 
  };

  const callTokenRequest = (request) => {
    const url = "https://flex-services.onrender.com/refreshToken/"
    //const settings = {headers: {withCredentials:true}} //credential: "same-origin",
    return axios.post(url, request.body, {headers: request.headers, withCredentials:true})
      .then(response => { 
        if (!response.data["log"]) {
          return setRefreshTokenAndCallRequest(request, response.data["access_token"]) 
        }
        else {
          history.push('/' + response.data["log"]["redirect"])
        }
      })
      .catch((error) => { return { managedError:false,  error :error} });
  };

  const callRequest = (request, accessToken=undefined) => {
    //if (withToken && !accessToken) accessToken = globalState.state.accessToken
    
    if (accessToken != undefined) {
      request.headers = {...request.headers, 'Authorization':'Token ' + accessToken,'X-CSRFToken': Cookies.get("UBINI_XSRF-Token")}
    }
    
    
    if (request.method == "POST")
      return  axios.post(request.url, request.body, {headers: request.headers, withCredentials:true})
        .then(response => { return { managedError:true,  result :response} })
        .catch((error) => { console.log(error); return { managedError:false,  text:"Unable to process this request, please contact the support for assistance", error :error} });
    if (request.method == "PATCH")
      return  axios.patch(request.url, request.body, {headers: request.headers, withCredentials:true})
        .then(response => { return { managedError:true,  result :response} })
        .catch((error) => { console.log(error); return { managedError:false,  text:"Unable to process this request, please contact the support for assistance", error :error} });

    if (request.method == "GET")
      return  axios.get(request.url, {headers: request.headers, withCredentials:true})
        .then(response => { return { managedError:true,  result :response} })
        .catch((error) => { console.log(error); return { managedError:false,  text:"Unable to process this request, please contact the support for assistance", error :error} });

    if (request.method == "DELETE")
      return  axios.delete(request.url, {headers: request.headers, withCredentials:true})
        .then(response => { return { managedError:true,  result :response} })
        .catch((error) => { console.log(error); return { managedError:false,  text:"Unable to process this request, please contact the support for assistance", error :error} });

  };

  const setRefreshTokenAndCallRequest = (request, token) => {
    dispatch({
      type: "SET_ACCESS_TOKEN",
      payload: {accessToken: token }, //payload: {user:globalState.state.user, accessToken: token },
    });
    return callRequest(request, token)
  };
  
  return callAxios;
};

export default useAxiosOperation;
